import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from './alert-notify.service';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Alert,AlertType } from './alert-notify.model';

@Component({
    selector: 'app-alert-notify',
    templateUrl: './alert-notify.component.html',
    styleUrls: ['./alert-notify.component.css'],
    standalone: false
})
export class AlertNotifyComponent implements OnInit,OnDestroy {
  @Input() id = 'default-alert';
  @Input() fade = true;

  alerts: Alert[] =[] ;
  alertSubscription!: Subscription;
  routeSubscription!: Subscription;

  constructor(private router: Router, private alertService: AlertService) { }

  ngOnInit() {
    // subscribe to new alert notifications
    this.alertSubscription = this.alertService.onAlert(this.id)
        .subscribe(alert => {
            // clear alerts when an empty alert is received
            if (!alert.message) {
                // filter out alerts without 'keepAfterRouteChange' flag
                this.alerts = this.alerts.filter(x => x.keepAfterRouteChange);

                // remove 'keepAfterRouteChange' flag on the rest
                this.alerts.forEach(x => delete x.keepAfterRouteChange);
                return;
            }
            console.log(alert)

            // Keep one visible copy when duplicate responses emit the same notification.
            this.alerts = this.alerts.filter(x => x.type !== alert.type || x.message !== alert.message);

            // add alert to array
            this.alerts.push(alert);

            // auto close alert if required
            if (alert.autoClose) {
                setTimeout(() => this.removeAlert(alert), 7000);
            }
       });


       this.routeSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
            this.alertService.clear(this.id);
        }
    });
}

ngOnDestroy() {
    // unsubscribe to avoid memory leaks
    this.alertSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
}

removeAlert(alert: Alert) {
  // check if already removed to prevent error on auto close
  if (!this.alerts.includes(alert)) return;

  if (this.fade) {
      // fade out alert
      

      // remove alert after faded out
      setTimeout(() => {
          this.alerts = this.alerts.filter(x => x !== alert);
      }, 250);
  } else {
      // remove alert
      this.alerts = this.alerts.filter(x => x !== alert);
  }
}

cssClass(alert: Alert) {
  if (!alert) return;

  const classes = ['alert', 'alert-dismissable'];
          
  const alertTypeClass = {
      [AlertType.Success]: 'alert-success',
      [AlertType.Error]: 'alert-danger',
      [AlertType.Info]: 'alert-info',
      [AlertType.Warning]: 'alert-warning'
  }

  classes.push(alertTypeClass[alert.type]);

  if (alert.fade) {
      classes.push('fade');
  }

  return classes.join(' ');
}

}
